import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import * as _ from 'lodash';

export interface IpProfileDialogInf {
  selectedItem: any;
  isEditMode?: boolean;
  ipProfileDefinition: any;
}

@Component({
  selector: 'ip-profile-dialog',
  templateUrl: './ip-profile-dialog.component.html',
  styleUrls: ['./ip-profile-dialog.component.scss']
})
export class IpProfileDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<IpProfileDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: IpProfileDialogInf,
              private formBuilder: FormBuilder) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  ipProfileOptions: any = {};

  ngOnInit(): void {
    this.initializeIpProfileOptions();
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data.selectedItem);
  }

  initializeIpProfileOptions(): void {
    const ipProfileDefinition = this.data.ipProfileDefinition;

    for (const ipProfile in ipProfileDefinition) {
      if (!ipProfileDefinition.hasOwnProperty(ipProfile)) { continue; }

      for (const prop in ipProfileDefinition[ipProfile]) {
        if (!ipProfileDefinition[ipProfile].hasOwnProperty(prop)) { continue; }

        const ipProfileOption = {text: ipProfileDefinition[ipProfile][prop], value: prop};
        if (!_.isNil(this.ipProfileOptions[ipProfile])) {
          this.ipProfileOptions[ipProfile].push(ipProfileOption);
        } else {
          this.ipProfileOptions[ipProfile] = [ipProfileOption];
        }
      }
    }
  }

}
